<template>
  <a-card :bordered="false">
    <a-table :columns="columns" :pagination="false" :data-source="dataSource" :loading="loading" @change="onTableChange">
      <template #major="{ text }">
        <dict-render :dict-obj="dictObjs['education_major']" :text="text"></dict-render>
      </template>
      <template #educationBackground="{ text }">
        <dict-render :dict-obj="dictObjs['education_background']" :text="text"></dict-render>
      </template>
    </a-table>
  </a-card>
</template>

<script>
import { tableListMixin, dictMixin } from "@/mixins";
import { eduExpriseInfo } from "@/api/educationService";
import { dateFormat } from "@/config/variableConfig";
import DictRender from "@/components/other/DictRender";

const columns = [
  // {title: "#", dataIndex: "index", key: "index", slots: {customRender: "index"}},
  { title: "学校名称", dataIndex: "schoolName", key: "schoolName" },
  { title: '入学时间', dataIndex: "entryTime", key: "entryTime" },
  { title: '毕业时间', dataIndex: "graduationTime", key: "graduationTime" },
  { title: '所学专业', dataIndex: "major", key: "major", slots: { customRender: "major" } },
  { title: '所获学历', dataIndex: "educationBackground", key: "educationBackground", slots: { customRender: "educationBackground" } },
  { title: "操作", dataIndex: "action", key: "action", slots: { customRender: "action" } },
];
export default {
  name: "index",
  mixins: [tableListMixin, dictMixin],
  components: {
    DictRender
  },
  data() {
    return {
      dictNames: 'education_major,education_background',
      dateFormat,
      columns,
      queryParam: {},
      listUrl: eduExpriseInfo.pageList,
      listKeyField: "id",
    }
  },
}
</script>

<style scoped></style>
